// Avatar-initial utility to ensure consistent initial extraction across the application
export const getInitials = (name?: string | null, fallback: string = '', uppercase: boolean = true): string => {
  if (!name) return fallback
  const initial = name.charAt(0)
  return uppercase ? initial.toUpperCase() : initial
}

// User color utility to ensure consistent colors across the application
export const getUserColor = (userId: string, index: number = 0): string => {
  // Generate a consistent color based on user ID or index
  const colors = [
    '#FF6B6B', // Red
    '#4ECDC4', // Teal
    '#45B7D1', // Blue
    '#96CEB4', // Green
    '#FFEAA7', // Yellow
    '#DDA0DD', // Plum
    '#98D8C8', // Mint
    '#F7DC6F', // Gold
    '#FF9F43', // Orange
    '#A55EEA', // Purple
    '#26DE81', // Green
    '#FD79A8', // Pink
  ]
  
  // Use user ID hash for consistent color assignment
  if (userId) {
    const hash = userId.split('').reduce((a, b) => {
      a = ((a << 5) - a) + b.charCodeAt(0)
      return a & a
    }, 0)
    return colors[Math.abs(hash) % colors.length]
  }
  
  // Fallback to index-based color
  return colors[index % colors.length]
}

export const getUserColors = (): string[] => {
  return [
    '#FF6B6B', // Red
    '#4ECDC4', // Teal
    '#45B7D1', // Blue
    '#96CEB4', // Green
    '#FFEAA7', // Yellow
    '#DDA0DD', // Plum
    '#98D8C8', // Mint
    '#F7DC6F', // Gold
    '#FF9F43', // Orange
    '#A55EEA', // Purple
    '#26DE81', // Green
    '#FD79A8', // Pink
  ]
}
